module.exports = __webpack_public_path__ + "static/media/cr.fb41aa11.png";